<template>
	<div class="pay-situation-container">
		<!-- 年份选择 -->
		<div class="year-picker-select">
			<mobile-button color="#808080" @click="selectYear">
				<span class="flex-select">
					<span>{{ yearText }}</span>
					<van-icon name="arrow-down" />
				</span>
			</mobile-button>
		</div>
		<div class="content">
			<div v-if="!loading && !$utils.isEmpty(list)">
				<div class="card-wrapper" v-for="(item, index) in list" :key="index">
					<mobile-card :show-title="false" :show-footer="true">
						<template slot="content">
							<div class="flex-form-info">
								<span>{{ pageText.list.name }}</span>
								<span>{{ item.itemName }}</span>
							</div>

							<div class="flex-form-info">
								<span>{{ pageText.list.range }}</span>
								<span>{{ item.intervalName }}</span>
							</div>

							<div class="flex-form-info">
								<span>{{ pageText.list.need_money }}</span>
								<span class="money-item">{{ item.needPay | formatMoney }}</span>
							</div>

							<div class="flex-form-info">
								<span>{{ pageText.list.later_money }}</span>
								<span>{{ item.laterPay | formatMoney }}</span>
							</div>

							<div class="flex-form-info">
								<span>{{ pageText.list.receive_money }}</span>
								<span class="money-item">{{ item.realPay | formatMoney }}</span>
							</div>
						</template>

						<template slot="footer">
							<div class="flex-form-footer">
								<div class="flex-form-btn" @click="checkDetail(item)">
									<van-icon name="eye-o" />
									<span>{{ pageText.list.detail }}</span>
								</div>

								<div class="flex-form-btn" @click="download(item)" v-if="item.ticketed">
									<van-icon name="down" />
									<span>{{ pageText.list.download }}</span>
								</div>
							</div>
						</template>
					</mobile-card>
				</div>
			</div>

			<van-overlay :show="loading" @click="loading = false">
				<div style="display: flex; align-items: center; justify-content: center; height: 100%" @click.stop>
					<van-loading vertical>{{ pageText.loading }}</van-loading>
				</div>
			</van-overlay>

			<div v-if="$utils.isEmpty(list) && !loading" class="empty-block">
				<span>{{ emptyText }}</span>
			</div>
		</div>
		<div class="btn-back">
			<van-button color="#005423" block @click="onBack">{{ pageText.pre_page }}</van-button>
		</div>
		<van-popup v-model="showYearPicker" position="bottom">
			<van-picker
				show-toolbar
				:title="pageText.choose_year"
				:columns="yearColumns"
				:default-index="defaultIndex"
				:cancel-button-text="pageText.cancel_text"
				:confirm-button-text="pageText.confirm_text"
				@cancel="showYearPicker = false"
				@confirm="onConfirm"></van-picker>
		</van-popup>
	</div>
</template>

<script>
import log from 'utils/log'
import MobileCard from 'components/mobile-card/index'
import apiPaySituation from 'api/pay-situation'
import moment from 'moment'
import storage from 'good-storage'
import MobileButton from 'components/mobile-button/index'
import { Overlay } from 'vant'

const defaultYear = moment().year()

export default {
	name: 'pay-situation',
	components: { MobileButton, MobileCard },
	data() {
		return {
			defaultIndex: 0,
			year: null,
			yearText: '',
			list: [],
			yearColumns: [],
			showYearPicker: false,
			loading: false,
			emptyText: this.$t('pay_situation.emptyText'),
			pageText: {
				choose_year: this.$t('pay_situation.choose_year'),
				cancel_text: this.$t('pay_situation.cancel_text'),
				confirm_text: this.$t('pay_situation.confirm_text'),
				pre_page: this.$t('pay_situation.pre_page'),
				loading: this.$t('pay_situation.loading'),
				list: {
					name: this.$t('pay_situation.list.name'),
					range: this.$t('pay_situation.list.range'),
					need_money: this.$t('pay_situation.list.need_money'),
					later_money: this.$t('pay_situation.list.later_money'),
					receive_money: this.$t('pay_situation.list.receive_money'),
					detail: this.$t('pay_situation.list.detail'),
					download: this.$t('pay_situation.list.download')
				}
			}
		}
	},

	created() {
		console.log('created---------')
		this.getColumns()
		this.getList()
	},

	methods: {
		onBack() {
			this.$router.back()
		},
		getList() {
			let self = this
			self.loading = true
			let param = {
				year: self.year
			}
			self.list = []
			apiPaySituation
				.list(param)
				.then(res => {
					log('res is ', res.data)
					self.list = res.data || []
					self.loading = false
				})
				.catch(err => {
					self.loading = false
				})
		},

		onConfirm(value, index) {
			log('value', value, index)
			this.showYearPicker = false
			this.defaultIndex = index
			this.yearText = value
			let v = Number(value)
			if (!Number.isNaN(v)) {
				this.year = v
			} else if (value === '全部' || value === 'All') {
				this.year = null
			} else {
				this.year = -1
			}
			this.getList()
		},

		getColumns() {
			let now = moment()
			let y = now.year() + 1
			this.yearColumns = [this.$t('pay_situation.all'), this.$t('pay_situation.no_range_year')]
			for (let index = 0; index < 6; index++) {
				this.yearColumns.push(y - index)
			}
			this.year = defaultYear
			this.yearText = defaultYear
			this.defaultIndex = 3
		},

		selectYear() {
			this.showYearPicker = true
		},

		download(item) {
			log('item is', item)
			storage.session.set('pay-item', item)
			this.$router.push({
				path: 'pay-situation-download'
			})
		},

		checkDetail(item) {
			log('item is', item)
			storage.session.set('pay-item', item)
			this.$router.push({
				path: 'pay-situation-detail'
			})
		}
	}
}
</script>

<style lang="scss" scoped></style>
